import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" {...props}>
      <g data-name="Designed by Freepik">
        <g data-name="Group 1580">
          <path
            data-name="Polygon 3"
            d="M36.38 8.21a7.66 7.66 0 017.7 7.64 7.59 7.59 0 01-1 3.89L31.54 39.47a7.67 7.67 0 01-13.27 0L7 19.82a7.67 7.67 0 016.6-11.51z"
            fill="#ff4040"
          />
          <text
            transform="translate(15.74 33.46)"
            style={{
              isolation: 'isolate'
            }}
            fontSize={35.28}
            fill="#fff"
            fontFamily="Rubik-Bold,Rubik"
            fontWeight={700}
            letterSpacing=".05em"
            data-name="-">
            {'-'}
          </text>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
